import React from 'react';
import { Button } from '@biq/apex-ui';
import { Grid, Paper, Typography } from '@mui/material';
import { dataTypeWarningStyles } from './attribute-helper';

interface DataTypeWarningProps {
    handleCancel?: () => void;
    handleConfirm?: () => void;
    isObjectDataType: boolean;
}

export const DataTypeWarning = ({
    handleCancel,
    handleConfirm,
    isObjectDataType,
}: DataTypeWarningProps): React.JSX.Element => {
    const getWarningMessage = (): string => {
        return `Changing the attribute type ${isObjectDataType ? 'will' : 'may'} change the structure of the tree. Do you want to continue?`;
    };

    return (
        <Paper sx={dataTypeWarningStyles.root}>
            <Grid sx={dataTypeWarningStyles.container}>
                <Typography sx={dataTypeWarningStyles.warningMessage}>
                    {getWarningMessage()}
                </Typography>
                <Grid sx={dataTypeWarningStyles.buttonContainer}>
                    <Button
                        size='small'
                        sx={dataTypeWarningStyles.confirmButton}
                        onClick={handleConfirm}
                    >
                        Change Type
                    </Button>
                    <Button
                        variant='text'
                        size='small'
                        sx={dataTypeWarningStyles.cancelButton}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
};
